export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      user: {
        userUuid: '1b2c6a69f00ab0ea7583ce9b3c58b4a5',
        name: '管理者 太郎',
        email: 'aaa@aaa.com',
        roleKbn: 1,
        service: {
          serviceUuid: 'サービスUUID',
          serviceName: 'サービス名'
        },
        linkedCmss: [
          {
            linkCMSMstId: 1,
            linkCMSName: '連携CMS名称',
            linkCMSURL: '連携CMS URL'
          }
        ],
        lastLoginAt: 1594880785395,
        mfaConfirmedAt: 1594880785395,
        passwordChanged: true
      },
      accessToken: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9kZXYuaW5zcGVjdGlvbi5qaXcuY28uanBcL2FwaVwvdjFcL2xvZ2luXC91c2VyIiwiaWF0IjoxNTgzNzMzNjY1LCJleHAiOjE1ODM4MjAwNjUsIm5iZiI6MTU4MzczMzY2NSwianRpIjoiZW51MnliN09pVVpINWZmUyIsInN1YiI6MjcsInBydiI6IjIzYmQ1Yzg5NDlmNjAwYWRiMzllNzAxYzQwMDg3MmRiN2E1OTc2ZjcifQ.1PnsyFSJKU6l3citm1ZOb2OxsbbP9VTaA8Itc_5O28k',
      expireIn: 120,
      timestamp: 1594880785395,
      hash: 'c10ecb53c96dda152fd0f8243a8e69eba7903f09dd5f718eb4557a06f6e8c4cb'
    }
  }
}